var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSidebarAccreditation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 20.7,
    viewBox: "0 0 19 20.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "key_black_24dp",
    transform: "translate(0 1.7)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9318",
    "data-name": "Group 9318"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7176",
    "data-name": "Rectangle 7176",
    width: 19,
    height: 19,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "approval_delegation_FILL0_wght200_GRAD0_opsz48",
    d: "M91.738,265.692l-3.247-3.247.521-.5,2.726,2.731,5.391-5.367.5.492Zm.756,10.927-7.465-2.193v1.209H81.542l0-8.557h5.868l5.739,2.122a1.786,1.786,0,0,1,.786.572,1.953,1.953,0,0,1,.334,1.25h3.193a1.291,1.291,0,0,1,1.135.559,2.636,2.636,0,0,1,.386,1.518v.1Zm-10.23-1.7h2.022l0-7.116H82.259Zm10.155.955,5.812-3.192a1.347,1.347,0,0,0-.243-.69.635.635,0,0,0-.528-.245H92.9a9.389,9.389,0,0,1-1.246-.085,6.2,6.2,0,0,1-1.082-.231l-1.951-.6.335-.728,1.692.6a5.561,5.561,0,0,0,1.131.258,15.637,15.637,0,0,0,1.729.07,1.653,1.653,0,0,0-.141-.731.8.8,0,0,0-.453-.4L87.316,267.8H85.024l0,5.855ZM84.28,270.647ZM93.505,271.022ZM84.28,270.647ZM85.024,270.647Z",
    transform: "translate(-80.759 -260.303)",
    fill: "none",
    stroke: "#d95579",
    strokeWidth: 1
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarAccreditation);
export default __webpack_public_path__ + "static/media/sidebar_accreditation.cdbf1cd6edf21a6cdc456eb1a82df6ad.svg";
export { ForwardRef as ReactComponent };